module.exports = __webpack_public_path__ + "static/media/microphone.a2374838.svg";